import { EyeFilled } from "@ant-design/icons";
import { Avatar, Button, message, Table } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { SERVER_ADDRESS } from "../../../Config/Config";
import { useNavigate } from "react-router-dom";

const Reels = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const fetch_reels = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/reels-users`);
      const result = response.data;
      console.log(result);
      if (result.result === 1) {
        setLoading(false);
        setData(result.data);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      message.error({ content: "Something went wrong" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch_reels();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      align: "center",
    },
    {
      title: "Profile",
      dataIndex: "profile",
      key: "profile",
      align: "center",
      render: (_, record) => {
        const profile = record.profile;
        return <Avatar src={profile} size={64} />;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
    },
    {
      title: "Options",
      key: "options",
      render: (_, record) => (
        <>
          <Button variant="filled">
            <EyeFilled
              onClick={() => {
                navigate("/verify-reels", { state: record });
              }}
            />
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ marginTop: "4rem" }}>
      <div
        className="mt-3 p-4"
        style={{ backgroundColor: "white", borderRadius: "1rem" }}
      >
        <h3 className="py-4">View Reels</h3>
        <div style={{ marginTop: "2rem" }}>
          <Table
            rowKey="id"
            dataSource={data}
            loading={loading}
            columns={columns}
          />
        </div>
      </div>
    </div>
  );
};

export default Reels;
